import React from 'react';
import { translate } from 'react-i18next';
import { ActivityIndicator, StyleSheet, Text, TouchableOpacity, ViewStyle } from 'react-native';
import CheckIcon from '../../assets/images/check.svg';
import PlusIcon from '../../assets/images/plus-icon.svg';
import { truncate } from '../../HomeWorkouts/components/Music/SongListItem';
import theme from '../../theme';
import { defaultScale } from '../../utils/scaling';

interface IProps {
  iconSize?: number;
  text: string;
  textMaxWidth: number;
  onPress: () => void;
  containerStyle?: ViewStyle;
  textStyle?: ViewStyle;
  setupCompleted?: boolean;
  subtext?: string;
  loading?: boolean;
}

export const SetupActionButton = translate(['tracking'], { wait: true })(
  ({
     iconSize = defaultScale(18),
     containerStyle,
     textStyle,
     onPress,
     text,
     loading = false,
     subtext,
     setupCompleted = false,
   }: IProps) => {

    const iconToRender = () => {
      if (loading) {
        return <ActivityIndicator animating color={theme.PRIMARY} size={iconSize} />;
      }
      if (setupCompleted) {
        return <CheckIcon color={theme.PRIMARY} width={iconSize} height={iconSize} />;
      }
      return <PlusIcon color={theme.PRIMARY} width={iconSize} height={iconSize} />;
    };

    return (
      <TouchableOpacity style={[styles.container, containerStyle]} onPress={onPress}>
        {iconToRender()}
        <Text style={[styles.text, textStyle]}>
          {text}
        </Text>
        {
          subtext &&
          <Text style={styles.subtext}>{truncate(subtext, 21)}</Text>
        }
      </TouchableOpacity>
    );
  },
);

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    ...theme.textStyle.bodyCopyReg,
    textAlign: 'center',
    marginTop: defaultScale(8),
  },
  subtext: {
    ...theme.textStyle.small,
    color: theme.GREY_MEDIUM,
    textAlign: 'center',
    marginTop: defaultScale(5),
  },
});
